// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  padding: 2rem 0;
}

.contact-hero {
  text-align: center;
  margin-bottom: 3rem;
  padding: 3rem 1rem;
  border-radius: 16px;
}
.contact-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(180deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.contact-subtitle {
  font-size: 1.1rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.contact-content {
  max-width: 800px;
  margin: 0 auto;
}

.contact-form-section {
  background: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 255, 157, 0.1);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.95rem;
}

.form-input,
.form-textarea {
  padding: 0.875rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s ease;
  background: white;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #279ede;
}

.form-textarea {
  resize: vertical;
  min-height: 150px;
}

.submit-button {
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #17e7f2 0%, #00a3ff 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(36, 150, 187, 0.3);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.button-arrow {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.submit-button:hover .button-arrow {
  transform: translateX(4px);
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.footer {
  margin-top: 4rem;
  padding: 3rem 0 1.5rem;
  border-top: 1px solid #e0e0e0;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 3rem;
  margin-bottom: 2rem;
}

.footer-section h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #00ff9d 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-section h4 {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #1a1a1a;
}

.footer-section p {
  color: #666;
  line-height: 1.6;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section ul li a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #00a3ff;
}

.footer-bottom {
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
  text-align: center;
}

.footer-bottom p {
  color: #999;
  margin: 0;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .contact-title {
    font-size: 2rem;
  }

  .contact-form-section {
    padding: 2rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 640px) {
  .contact-hero {
    padding: 2rem 1rem;
  }

  .contact-form-section {
    padding: 1.5rem;
  }

  .contact-title {
    font-size: 1.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/contact/Contact.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".contact-page {\n  padding: 2rem 0;\n}\n\n.contact-hero {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 3rem 1rem;\n  border-radius: 16px;\n}\n.contact-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(180deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.contact-subtitle {\n  font-size: 1.1rem;\n  color: #666;\n  max-width: 700px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.contact-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.contact-form-section {\n  background: white;\n  border-radius: 16px;\n  padding: 3rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 255, 157, 0.1);\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.form-input,\n.form-textarea {\n  padding: 0.875rem 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: inherit;\n  transition: border-color 0.3s ease;\n  background: white;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: #279ede;\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 150px;\n}\n\n.submit-button {\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, #17e7f2 0%, #00a3ff 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(36, 150, 187, 0.3);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.button-arrow {\n  font-size: 1.2rem;\n  transition: transform 0.3s ease;\n}\n\n.submit-button:hover .button-arrow {\n  transform: translateX(4px);\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.footer {\n  margin-top: 4rem;\n  padding: 3rem 0 1.5rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  gap: 3rem;\n  margin-bottom: 2rem;\n}\n\n.footer-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #00ff9d 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.footer-section h4 {\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  color: #1a1a1a;\n}\n\n.footer-section p {\n  color: #666;\n  line-height: 1.6;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: 0.5rem;\n}\n\n.footer-section ul li a {\n  color: #666;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-section ul li a:hover {\n  color: #00a3ff;\n}\n\n.footer-bottom {\n  padding-top: 1.5rem;\n  border-top: 1px solid #e0e0e0;\n  text-align: center;\n}\n\n.footer-bottom p {\n  color: #999;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-title {\n    font-size: 2rem;\n  }\n\n  .contact-form-section {\n    padding: 2rem;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .contact-hero {\n    padding: 2rem 1rem;\n  }\n\n  .contact-form-section {\n    padding: 1.5rem;\n  }\n\n  .contact-title {\n    font-size: 1.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
